// Resuelve la URL de un archivo venga como venga del backend.
// - Absoluta (http/https): se usa tal cual (ej. documentos ya guardan URL completa).
// - Relativa (/public/...): se antepone la base de la API (ej. media de FAQ).
// Mantiene la misma base que utils/axiosConfig.js.
const API_BASE = 'https://api.sinterec.cl';

export const resolverUrlArchivo = (url) => {
  if (!url || typeof url !== 'string') return null;
  if (/^https?:\/\//i.test(url)) return url; // ya es absoluta
  return `${API_BASE}${url.startsWith('/') ? '' : '/'}${url}`; // relativa → prepende base
};

export default resolverUrlArchivo;